// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fh","advertDetailContactGroup__header":"c-n_fi","advertDetailContactGroup__value":"c-n_fj"};